"use client";

import { cn, Typography } from "@kyan/ui";
import type { FC } from "react";

import { GreeksTable } from "#/components/GreeksTable/GreeksTable";

import { useComboGreeksTableController } from "./ComboGreeksTable.controller";
import { AutoHedge } from "./components/AutoHedge/AutoHedge";

export interface GreeksTableProps {
  className?: string;
}

export const ComboGreeksTable: FC<GreeksTableProps> = ({ className }) => {
  const { delta, gamma, vega, theta, perpDelta } =
    useComboGreeksTableController();

  return (
    <div className={cn("grid gap-2", className)}>
      <Typography>Strategy Greeks (Options)</Typography>
      <div className="flex gap-1.5">
        <GreeksTable vega={vega} delta={delta} variant="standalone" />
        <GreeksTable gamma={gamma} theta={theta} variant="standalone" />
      </div>

      <Typography>Perps</Typography>
      <div className="relative">
        <GreeksTable delta={perpDelta} />
        <AutoHedge />
      </div>
    </div>
  );
};
